module.exports = __webpack_public_path__ + "static/media/30.e27b6c2b.mp3";